import {
    SET_CREATE_ALERT_STATUS,
    SET_EDIT_ALERT,
    SET_MY_LIST_ALERT,
    SET_FINAL_VALUES,
    SET_ALERT_SUBMITTED,
    SET_VALUES,
    SET_LOCALIZATION_LANGUAGES,
    SET_ALERT_CATEGORIES,
    SET_DEVICES,
    SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC,
    SET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC,
    SET_COUNTRY_CODE,
    SET_ALERT_EDIT_ID
} from './types';


const reducers = (state: any = {}, action: any) => {
    switch (action.type) {
        case SET_CREATE_ALERT_STATUS:
            alert(action.values)
            return {
                ...state, createAlertStatus: action.values
            }

        case SET_EDIT_ALERT:
            return {
                ...state, createEditAlertData: action.values
            }
        case SET_ALERT_EDIT_ID:
            return {
                ...state, alertEditID: action.values
            }
        case SET_MY_LIST_ALERT:
            return {
                ...state, myListData: action.values
            }
        case SET_FINAL_VALUES:
            return {
                ...state, finalValue: action.values
            }
        case SET_ALERT_SUBMITTED: {
            return {
                ...state, alertSubmitted: action.alertSubmitted
            }
        }
        case SET_VALUES: {
            return {
                ...state, alertValues: action.values
            }
        }
        case SET_LOCALIZATION_LANGUAGES:
            return {
                ...state, GetLocalizationLanguages: action.values
            }
        case SET_ALERT_CATEGORIES:
            return {
                ...state, GetAlertCategories: action.values
            }
        case SET_DEVICES:
            return {
                ...state, GetDevicesAsync: action.values
            }
        case SET_UNSUBSCRIBETO_PUSH_NOTIFICATIONASYNC:
            {
                return {
                    ...state, UnSubscribeToPushNotificationAsync: action.values
                }
            }
        case SET_SUBSCRIBE_TO_PUSHNOTIFICATIONASYNC:
            {
                return {
                    ...state, SubscribeToPushNotificationAsync: action.values
                }
            }
        case SET_COUNTRY_CODE:
            return {
                ...state, CountryCodes: action.values
            }

        default:
            return state;
    }
};

export default reducers;




